import React, {FC, useEffect, useState} from "react";
import { getIndexData } from "./DashboardCRUD";
import { formatPrice } from "../../selectors";
import { ShowroomCharts } from "./ShowroomCharts";
import { useHistory } from "react-router-dom";

interface DashboardData {
  approved_product_count: number,
  new_import_request_count: number,
  rejected_product_count: number,
  total_sales_amount: number,
  last_month_total_sales_amount: number,
  total_import_requests: number,
  total_consignment_stores: number,
  total_stores: number,
  total_warehouse: number,
  total_warehouse_value: number
}
const DashboardPage: FC = () => {
  const [data, setData] = useState<DashboardData>()
  const history = useHistory();

  useEffect(() => {
		document.title = 'Sento Supplier - Thống kê chung';
	})

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const { data } = await getIndexData();
      setData(data.data)
    } catch (err: any) {

    }
  }

  const hanldeRedirect = (path: string) => {
    history.push(path)
  }

  const salesStatus = () => {
    let thisMonthSale = data?.total_sales_amount ?? 0;
    let lastMonthSale = data?.last_month_total_sales_amount ?? 0;
    if (lastMonthSale === 0) {
      return <></>
    }

    let perc = 100*(thisMonthSale - lastMonthSale)/lastMonthSale;
    return <span className={perc >= 0 ? 'text-success' : 'text-danger'}>
      <i className={perc >= 0 ? 'fa fa-arrow-up text-success' : 'fa fa-arrow-down text-danger'}></i> {perc.toFixed(2)}% so với tháng trước</span>
  }

  return <>
    <div className='row gy-5 g-xl-8'>
      <div className="col-12">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <div className="card">
              <div className="card-body cursor-pointer" onClick={() => hanldeRedirect('/products?status=approved')}>
                <h5 className="card-title">Sản phẩm đã duyệt</h5>
                <h2 className="text-primary">{formatPrice(data?.approved_product_count ?? 0)}</h2>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <div className="card">
              <div className="card-body cursor-pointer" onClick={() => hanldeRedirect('/warehouse/receipt/import-requests')}>
                <h5 className="card-title">
                  Yêu cầu nhập hàng
                </h5>
                <h2 className="text-primary">{formatPrice(data?.new_import_request_count ?? 0)}</h2>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <div className="card">
              <div className="card-body cursor-pointer" onClick={() => hanldeRedirect('/warehouse-report')}>
                <h5 className="card-title">Tồn kho: {formatPrice(data?.total_warehouse_value ?? 0)}</h5>
                <h5 className="card-title">Sản phẩm tồn: {formatPrice(data?.total_warehouse ?? 0)}</h5>
                <p></p>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 col-lg-3 mb-2">
            <div className="card">
              <div className="card-body cursor-pointer" onClick={() => hanldeRedirect('/warehouse-report')}>
                <h5 className="card-title">
                  Doanh thu tháng
                </h5>
                <h2 className="text-primary">{formatPrice(data?.total_sales_amount ?? 0)}</h2>
                {salesStatus()}
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <ShowroomCharts
        className='mb-5'
        colorBase='--bs-primary'
        totalImportRequests={data?.total_import_requests ?? 0}
        totalConsignmentStores={data?.total_consignment_stores ?? 0}
        totalStores={data?.total_stores ?? 0}
      />
    </div>
  </>
}
export default DashboardPage;